var Navigation = function(gal){
	var _this = this;

	var navOpenedTime = 3000,
		/* Mobile Open/Close Navigation */
		mobileCloseBtn = dom.getById("close-mobile"),
		navIsOpen = false,
		nav = dom.getById("navigation"),
		containerWrapper = dom.getById("container-wrapper");


	function _toggleNav(){

		/*var navTop = dom.getById('main').clientHeight + dom.getById('sidebar').clientHeight;
		scrollTo(dom.getById('scroll-content'), navTop, 500);   */

	
		if (navIsOpen) {
			$('#btn-back, #center-btns').hide();
			// $("#navigation").animate({
			// 	height: 0
			// },200);

			navIsOpen = false;
			if(nav){
				dom.removeClass(nav, "opened");
			}

			$("#main .t-scroll").removeClass("nav-open");
			return;
		}
		

		navIsOpen = true;
		// $("#navigation").animate({
		// 	height: 60
		// },200, function(){
			$('#btn-back, #center-btns').fadeIn(200);
			
			if(nav){
				dom.addClass(nav, "opened");
			}

			$("#main .t-scroll").addClass("nav-open");
		// });
	}

	function _openNav() {
		navIsOpen = true;
		dom.addClass(nav, 'open');
		dom.addClass(containerWrapper, 'fit');
		dom.addClass("#view-main-wrapper .t-scroll", "nav-open");
	}

	function _closeNav() {
		navIsOpen = false;
		dom.removeClass(nav, 'open');
		dom.removeClass(containerWrapper, 'fit');
		dom.removeClass("#view-main-wrapper .t-scroll", "nav-open");
	}

	function _navIsOpen(){
		return navIsOpen;
	}

	function _init(){
		if(isMobile && typeof mobileCloseBtn !== 'undefined' && mobileCloseBtn){
			mobileCloseBtn.addEventListener('click', _toggleNav, true);
			
			window.addEventListener('view.gallery.inited', function(event){
				// dom.getById("close-mobile").click();
				_toggleNav();
				helpers.toggleBtnAnimation('btn-notification', 'tada', 1000);
				var navTimeout = setTimeout(function(){
					var nav = dom.getById("navigation");

					if(typeof gal !== 'undefined' && typeof gal.isAtEnd !== 'undefined' && gal.isAtEnd()){
						return; // If on last brochure page, do not close navigation.
					}

					if(dom.hasClass(nav, "opened")){
						// dom.getById("close-mobile").click();
						_toggleNav();
						
					}
				}, navOpenedTime);
			});

			window.addEventListener('view.navigation.toggleNav', function(event){
				_toggleNav();
			});
		}
	}

	_this.init = _init;
	_this.navIsOpen = _navIsOpen;
	_this.closeNav = _closeNav;
	_this.openNav = _openNav;
	_this.toggleNav = _toggleNav;
};